// extracted by mini-css-extract-plugin
export var content = "_oq-1";
export var noScroll = "_oq-3";
export var paper = "_oq-0";
export var scrollable = "_oq-2";